import { handleActions } from "redux-actions";
import { fetchActions, IFetchStoreState, initialFetchState, updateActions } from "reducers/base-reducers";
import { VARIANTS } from "constants/action-types";
import { IVariant } from "records/item/item";

export interface IVariantsMap {
    [product: string]: IVariant[];
}

export type IVariantsState = IFetchStoreState<IVariantsMap>;

export const variants = handleActions<IVariantsState>(
    {
        ...fetchActions<IVariantsMap>(VARIANTS.FETCH),
        ...updateActions<IVariantsMap>(VARIANTS),
    } as any,
    {
        ...initialFetchState,
        payload: {},
    },
);
